// Define allowed predefined events
export type PredefinedActivity = 'login';

// Allow predefined OR any other string for custom events
export type ActivityEvent = PredefinedActivity | (string & {});

export const logActivity = async (userId: string, eventName: ActivityEvent, metadata: any = {}) => {
  try {
    const token = localStorage.getItem('subscale_auth_token') || '';

    await fetch('/api/activities', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'X-API-Key': token, Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ userId, eventName, metadata })
    });
  } catch (error) {
    console.error('Failed to log activity:', error);
  }
};
